import { render, staticRenderFns } from "./OneCmsStaticBanners.vue?vue&type=template&id=523b8fd0&scoped=true&"
import script from "./OneCmsStaticBanners.vue?vue&type=script&lang=ts&"
export * from "./OneCmsStaticBanners.vue?vue&type=script&lang=ts&"
import style0 from "./OneCmsStaticBanners.vue?vue&type=style&index=0&id=523b8fd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b8fd0",
  null
  
)

export default component.exports